var map = {
	"./bmc-logo.svg": 521,
	"./cross.svg": 44,
	"./crown.svg": 90,
	"./external-link.svg": 87,
	"./gear.svg": 522,
	"./github.svg": 523,
	"./info.svg": 524,
	"./lightning.svg": 525,
	"./reload-arrow.svg": 91,
	"./send.svg": 92,
	"./tick.svg": 526,
	"./warning.svg": 527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 520;